import React, { useState, useEffect, useRef } from "react"

const AccordionButton = ({
  id,
  isFirst,
  title,
  content,
  handleToggle,
  onItemClick,
  isOpen,
  properties = {
    background: "bg-transparent",
    title: "1024:text-white text-neutral-800 1024:font-bold font-semibold",
    content: "text-_1425 1024:text-white text-neutral-800",
    padding: "py-6",
  },
  openProperties = {
    background: "bg-transparent",
    title: "text-dorot-purple 1024:font-bold font-semibold",
    content: "text-_1425 1024:text-white text-neutral-800",
    padding: "py-6",
  },
  iconProperties = {
    css: "text-black text-_2432 absolute right-2 top-2.5",
    icon: "+",
  },
  iconOpenProperties = {
    css: "text-dorot-purple text-_2432 absolute right-2 top-2.5",
    icon: "−",
  },
}) => {
  // console.log("🚀 ~ properties:", properties)
  const thisDiv = useRef(id)
  const [initialState, setInitialState] = useState(isFirst)

  useEffect(() => {
    if (isOpen && !initialState) {
      // thisDiv.current.scrollIntoView({
      //   behavior: "smooth",
      //   block: "center",
      // })
    }
  }, [isOpen])
  useEffect(() => {
    if (initialState) {
      handleToggle(id)
      setInitialState(false)
    }
  }, [])

  return (
    <div
      id={id}
      className={`relative border-b border-solid border-dorot-purple ${
        isOpen
          ? `${openProperties.padding} ${openProperties.background}`
          : `${properties.padding} ${properties.background}`
      }`}
      ref={thisDiv}
    >
      <button
        aria-expanded={isOpen}
        className="flex justify-between text-left items-center w-full"
        onClick={() => {
          if (onItemClick) {
            onItemClick({ id, title, isOpen })
          }
          if (handleToggle) {
            handleToggle(id)
          }
        }}
      >
        <h3
          className={`text-_1632 1024:text-_2430 font-goldplay ${
            isOpen ? openProperties.title : properties.title
          }`}
        >
          {title}
        </h3>
        <span
          aria-hidden="true"
          className={isOpen ? iconOpenProperties.css : iconProperties.css}
        >
          {isOpen ? iconOpenProperties.icon : iconProperties.icon}
        </span>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out text-_1425 md:text-_2025 font-goldplay font-semibold ${
          isOpen
            ? "grid-rows-[1fr] opacity-100 mt-5"
            : "grid-rows-[0fr] opacity-0 mt-0"
        }`}
      >
        <div
          className={`overflow-hidden whitespace-pre-line text-dorot-purple ${
            isOpen ? openProperties.content : properties.content
          }`}
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      </div>
    </div>
  )
}

export default AccordionButton
